(function() {

	angular
		.module('ngmvac')
		.filter('boardPackagesFilter', BoardPackagesFilter);

		function BoardPackagesFilter() {
			return function (arr) {
				var boardsArray = [];
				var boardsNameArraycount = [];
				var boardsNameArraycount2 = [];




	      angular.forEach(arr, function(hotel) {
					angular.forEach(hotel.packageGrouped, function(group) {

						boardsNameArraycount.push(group);

					
                    })
				});



				      for(var a=0; a<boardsNameArraycount.length; a++)
				      {

	      					  boardsNameArraycount2.push(boardsNameArraycount[a][0].boardName);

	     			 }


	  

				    Array.prototype.count_value = function()
				    {
						var count = {};
						for(var i = 0; i < this.length; i++){
						if(!(this[i] in count))count[this[i]] = 0;
						count[this[i]]++;
						}
						return count;
					}						


               boardsNameArraycount2=boardsNameArraycount2.count_value();

            
              angular.forEach(arr, function(hotel) {
					angular.forEach(hotel.packageGrouped, function(group) {


						angular.forEach(group, function(pack) {
							boardsArray.push({
								boardCode: pack.boardCode,
								boardName: pack.boardName,
								count:  boardsNameArraycount2
								
							});
						})
					})
				});


		
           		





				return boardsArray;
			}
		}

})();